import { render, staticRenderFns } from "./ProjectPerformance.vue?vue&type=template&id=61cb0992&scoped=true"
import script from "./ProjectPerformance.vue?vue&type=script&lang=js"
export * from "./ProjectPerformance.vue?vue&type=script&lang=js"
import style0 from "./ProjectPerformance.vue?vue&type=style&index=0&id=61cb0992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cb0992",
  null
  
)

export default component.exports